import React, {Component} from 'react'
import {
    Link,
    Redirect
} from 'react-router-dom'
import {AppContext, Features} from '@lightspeed-invoicing/core-client/frontend'
import {FormattedMessage, injectIntl, defineMessages} from 'react-intl'
import ConfirmButton from "../../common/button/confirmbutton.component.jsx"
import Icon from "../../common/icon/icon.component.jsx";
import LoadingSpinner from '../../common/spinner/loading.component.jsx'

import Select from "react-select";

const iconOptions = [
    {value: "dollar-sign", label: <Icon value={"dollar-sign"}/>,},
    {value: "money-check", label: <Icon value={"money-check"}/>,},
    {value: "money-bill-alt", label: <Icon value={"money-bill-alt"}/>},
    {value: "credit-card", label: <Icon value={"credit-card"}/>},
    {value: "university", label: <Icon value={"university"}/>},
    {value: "piggy-bank", label: <Icon value={"piggy-bank"}/>},
    {value: "gift", label: <Icon value={"gift"}/>},
    {value: "coins", label: <Icon value={"coins"}/>},
    {value: "cloud", label: <Icon value={"cloud"}/>},
];

class PaymentTypeEditForm extends Component {

    constructor(props, context) {
        super(props, context);

        this.state = {
            id: '',
            name: '',
            description: '',
            status: 'enabled',
            icon: 'credit-card',
            formStatus: '',
            deleteButton: '',
            externalPaymentTypesByIntegration: {},
            externalIdsMapping: {},
            loading: false,
        }

        this.submit = this.submit.bind(this)
        this.handleFormChange = this.handleFormChange.bind(this)
        this.handleExternalPaymentTypeChange = this.handleExternalPaymentTypeChange.bind(this)
        this.handleIconChange = this.handleIconChange.bind(this)
        this.handleFocus = this.handleFocus.bind(this)
        this.remove = this.remove.bind(this)
    }

    componentDidMount() {
        this.setState({
            loading: true,
        })

        const paymentType = this.props.paymentType
        if (paymentType && paymentType.id) {
            this.loadPaymentType(paymentType)

            const externalLinks = paymentType && paymentType.attributes.externalLinks ? paymentType.attributes.externalLinks : []
            let externalIdsMapping = {}
            for (let externalLink of externalLinks) {
                externalIdsMapping[externalLink.attributes.integrationKey] = externalLink.attributes.externalId
            }
            this.setState({
                externalIdsMapping,
            })
        }

        AppContext.getApiClient().get('/external-payment-types').then(res => {
            const externalPaymentTypesByIntegration = {}
            for (let paymentType of res.data) {
                if (!externalPaymentTypesByIntegration[paymentType.integrationKey]) {
                    externalPaymentTypesByIntegration[paymentType.integrationKey] = []
                }
                externalPaymentTypesByIntegration[paymentType.integrationKey].push(paymentType)
            }
            this.setState({
                externalPaymentTypesByIntegration,
                loading: false,
            })
        })
    }

    loadPaymentType(paymentType) {
        const deleteButton = <ConfirmButton identifier={paymentType.attributes.name} onClick={this.remove}
                                            className="btn btn-danger">
            <FormattedMessage
                id="payment_type.form.edit.delete_btn"
                defaultMessage="Delete payment type"
            />
        </ConfirmButton>
        this.setState({
            id: paymentType.id,
            name: paymentType.attributes.name,
            description: paymentType.attributes.description,
            status: paymentType.attributes.status,
            icon: paymentType.attributes.icon,
            paymentType: paymentType,
            deleteButton: deleteButton,
        })
    }

    remove(event) {
        AppContext.getApiClient().delete('/payment-types/' + this.state.id).then(response => {
            if (!response.error) {
                this.setState({formStatus: <Redirect to={{pathname: '/payment-types/listing'}}/>})
            }
        })
        event.preventDefault()
    }

    save() {
        if (this.state.paymentType && this.state.id) {
            let updates = {}
            const allowedFields = [
                "name",
                "description",
                "status",
                "icon",
                "externalIdsMapping",
            ]
            for (let i = 0; i < allowedFields.length; i++) {
                let field = allowedFields[i]
                if (this.state.paymentType.attributes[field] != this.state[field]) {
                    updates[field] = this.state[field]
                }
            }
            if (this.state.organization) {
                updates.organization = this.state.organization
            }
            return AppContext.getApiClient().patch('/payment-types/' + this.state.id, updates)
        } else {
            return AppContext.getApiClient().post('/payment-types', {
                "name": this.state.name,
                "description": this.state.description,
                "status": this.state.status,
                "icon": this.state.icon,
                "externalIdsMapping": this.state.externalIdsMapping,
            })
        }
    }

    submit(event) {
        event.preventDefault()
        this.save().then(response => {
            if (!response.error) {
                this.setState({formStatus: <Redirect to={{pathname: '/payment-types/listing'}}/>})
            }
        })
        event.preventDefault()
    }

    handleFocus(event) {
        event.target.select()
    }

    handleFormChange(event) {
        const target = event.target;
        let value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;

        this.setState({
            [name]: value
        });
    }

    handleIconChange(event) {
        if (event) {
            this.setState({
                icon: event.value,
            });
        }
    }

    handleExternalPaymentTypeChange(event) {
        const target = event.target;
        let value = target.value;
        const name = target.name;

        let externalIdsMapping = Object.assign({}, this.state.externalIdsMapping)
        externalIdsMapping[name] = value

        this.setState({
            externalIdsMapping,
        });
    }

    render() {
        if (this.state.loading) {
            return <LoadingSpinner/>
        }

        const messages = defineMessages({
            "name_placeholder": {
                id: 'payment_type.form.edit.name_placeholder',
                defaultMessage: 'Name of the payment type',
            },
            "description_placeholder": {
                id: 'payment_type.form.edit.description_placeholder',
                defaultMessage: 'Description of the payment type',
            },
            "save_btn": {
                id: 'payment_type.form.edit.save_btn',
                defaultMessage: 'Save',
            },
            "payment_type.form.edit.status_disabled_label": {
                id: 'payment_type.form.edit.status_disabled_label',
                defaultMessage: 'Disabled',
            },
            "payment_type.form.edit.status_enabled_label": {
                id: 'payment_type.form.edit.status_enabled_label',
                defaultMessage: 'Enabled',
            },
            "payment_type.form.edit.payment_type_select": {
                id: "payment_type.form.edit.payment_type_select",
                defaultMessage: "Select an option"
            }
        })

        return (
            <form onSubmit={this.submit} className="needs-validation" id="payment-type-form">
                <div className="row ui-has-modules">
                    <div className="col-12 ui-module">
                        <div className="form-group row mb-2">
                            <label className="col-2 col-form-label text-align-right" htmlFor="name">
                                <FormattedMessage
                                    id="payment_type.form.edit.name_label"
                                    defaultMessage="Name"
                                />
                            </label>
                            <div className="col-10 mb-3">
                                <input
                                    name="name"
                                    value={this.state.name}
                                    onChange={this.handleFormChange}
                                    id="name"
                                    type="text"
                                    className="form-control"
                                    placeholder={this.props.intl.formatMessage(messages['name_placeholder'])}
                                    required/>
                                <div className="invalid-feedback">
                                    <FormattedMessage
                                        id="payment_type.form.edit_name_field_error"
                                        defaultMessage="Payment Type name is required"
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="form-group row mb-2">
                            <label className="col-2 col-form-label text-align-right" htmlFor="description">
                                <FormattedMessage
                                    id="payment_type.form.edit.description_label"
                                    defaultMessage="Description"
                                />
                            </label>
                            <div className="col-10 mb-3">
                                <input
                                    name="description"
                                    value={this.state.description}
                                    onChange={this.handleFormChange}
                                    id="description"
                                    type="text"
                                    className="form-control"
                                    placeholder={this.props.intl.formatMessage(messages['description_placeholder'])}
                                />
                            </div>
                        </div>
                        <div className="form-group row mb-2">
                            <label className="col-2 col-form-label text-align-right" htmlFor="icon">
                                <FormattedMessage
                                    id="payment_type.form.edit.icon_label"
                                    defaultMessage="Icon"
                                />
                            </label>
                            <div className="col-10 mb-3">
                                <Select
                                    defaultValue={iconOptions[0]}
                                    options={iconOptions}
                                    id={'icon'}
                                    name={'icon'}
                                    value={this.state.icon}
                                    onChange={this.handleIconChange}
                                />
                                <small className="form-text text-muted">
                                    <FormattedMessage
                                        id="payment_type.form.edit.icon_description"
                                        defaultMessage="The icon that will appear next to the payments of this type"
                                    />
                                </small>
                            </div>
                        </div>
                        <div className="form-group row mb-2">
                            <label className="col-2 col-form-label text-align-right" htmlFor="status">
                                <FormattedMessage
                                    id="payment_type.form.edit.status_label"
                                    defaultMessage="Status"
                                />
                            </label>
                            <div className="col-10 mb-3">
                                <select
                                    name="status"
                                    value={this.state.status}
                                    onChange={this.handleFormChange}
                                    id="status"
                                    className="form-control"
                                >
                                    <option value="disabled">
                                        {this.props.intl.formatMessage(messages['payment_type.form.edit.status_disabled_label'])}
                                    </option>
                                    <option value="enabled">
                                        {this.props.intl.formatMessage(messages['payment_type.form.edit.status_enabled_label'])}
                                    </option>
                                </select>
                                <small className="form-text text-muted">
                                    <FormattedMessage
                                        id="payment_type.form.edit.status_description"
                                        defaultMessage="If disabled, you won't be able to select this payment type for your future payments"
                                    />
                                </small>
                            </div>
                        </div>
                        {
                            Object.keys(this.state.externalPaymentTypesByIntegration).map((integrationKey) => {
                                return <div className="form-group row mb-2">
                                    <label className="col-2 col-form-label text-align-right" htmlFor={integrationKey}>
                                        <FormattedMessage
                                            id="payment_type.form.edit.external_payment_type_label"
                                            defaultMessage="External payment type"
                                        />
                                    </label>
                                    <div className="col-10 mb-3">
                                        <select
                                            name={integrationKey}
                                            value={this.state.externalIdsMapping[integrationKey]}
                                            onChange={this.handleExternalPaymentTypeChange}
                                            id={integrationKey}
                                            className="form-control"
                                            required
                                        >
                                            <option value={""}>
                                                {this.props.intl.formatMessage(messages['payment_type.form.edit.payment_type_select'])}
                                            </option>
                                            {
                                                this.state.externalPaymentTypesByIntegration[integrationKey].map(externalPaymentType => {
                                                    return <option value={externalPaymentType.externalId}>
                                                        {externalPaymentType.name}
                                                    </option>
                                                })
                                            }
                                        </select>
                                    </div>
                                </div>
                            })
                        }
                    </div>

                    <div className="col-12">
                        {this.state.formStatus}
                    </div>
                    {(!this.state.id || (this.state.id && !this.state.paymentType.attributes.deletedBy)) &&
                    <div className="col-12 ui-module">
                        <div className="row">
                            <div className="col-6">
                                {this.state.deleteButton}
                            </div>
                            <div className="col-6 text-align-right">
                                <Link to="/payment-types/listing" className="btn btn-light">
                                    <FormattedMessage
                                        id="payment_type.form.edit.cancel_btn"
                                        defaultMessage="Cancel"
                                    />
                                </Link>
                                &nbsp;
                                &nbsp;
                                <input type="submit" value={this.props.intl.formatMessage(messages['save_btn'])}
                                       className="btn btn-primary"/>
                            </div>
                        </div>
                    </div>
                    }
                </div>
            </form>
        );
    }
}

export default injectIntl(PaymentTypeEditForm)


// WEBPACK FOOTER //
// ./src/payment-type/form/edit.component.jsx